import { buildResultTemplatesManager } from '/headless/v3.27.2/headless.esm.js';

class TemplateProvider {
    constructor(props, buildManager) {
        this.props = props;
        this.buildManager = buildManager;
        this.templateManager = this.buildManager();
        this.registerResultTemplates();
    }
    async registerResultTemplates() {
        const customTemplates = await Promise.all(this.props.templateElements.map(async (resultTemplateElement) => {
            if (!('getTemplate' in resultTemplateElement)) {
                await customElements.whenDefined(resultTemplateElement.tagName.toLowerCase());
            }
            const template = await resultTemplateElement.getTemplate();
            if (!template) {
                this.props.setTemplateHasError(true);
            }
            return template;
        }));
        const templates = (!customTemplates.length && this.props.includeDefaultTemplate
            ? [this.makeDefaultTemplate()]
            : []).concat(customTemplates.filter((template) => template));
        this.templateManager.registerTemplates(...templates);
        this.props.setResultTemplateRegistered(true);
    }
    getTemplateContent(item) {
        return this.templateManager.selectTemplate(item);
    }
    getLinkTemplateContent(item) {
        return this.templateManager.selectLinkTemplate(item);
    }
    getEmptyLinkTemplateContent() {
        return document.createDocumentFragment();
    }
    get templatesRegistered() {
        return this.props.getResultTemplateRegistered();
    }
    get hasError() {
        return this.props.getTemplateHasError();
    }
}

class ItemTemplateProvider extends TemplateProvider {
    constructor(props, gridCellLinkTarget) {
        super(props, () => buildResultTemplatesManager(props.bindings.engine));
        this.gridCellLinkTarget = gridCellLinkTarget;
    }
    // TODO: Add JSX support for default template
    makeDefaultTemplate() {
        const content = document.createDocumentFragment();
        const linkEl = document.createElement('atomic-result-link');
        content.appendChild(linkEl);
        const linkContent = document.createDocumentFragment();
        const linkMarkup = `
      <atomic-result-link>
      ${this.gridCellLinkTarget ? `<a slot="attributes" target="${this.gridCellLinkTarget}"></a>` : ''}
      </atomic-result-link>
    `;
        const linkTemplate = document.createElement('template');
        linkTemplate.innerHTML = linkMarkup.trim();
        linkContent.appendChild(linkTemplate.content);
        return {
            content,
            linkContent,
            conditions: [],
        };
    }
}

export { ItemTemplateProvider as I };

//# sourceMappingURL=item-template-provider-2fe32b5d.js.map